module.exports = __webpack_public_path__ + "static/media/paymobLogo.88575ae4.svg";